import { User, Clock } from 'lucide-react';
import { formatMyanmarDateTime } from '@/lib/dateUtils';

interface AuditInfoProps {
  createdByName?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  className?: string;
}

/**
 * Read-only audit info panel showing "Created by … on …" and optional "Updated …".
 * Renders nothing if no data is available.
 */
export default function AuditInfo({ createdByName, createdAt, updatedAt, className = '' }: AuditInfoProps) {
  if (!createdAt && !createdByName) return null;

  // Only show updatedAt when it differs meaningfully from createdAt
  const showUpdated =
    updatedAt &&
    createdAt &&
    Math.abs(new Date(updatedAt).getTime() - new Date(createdAt).getTime()) > 5000;

  return (
    <div className={`border-t border-slate-100 pt-3 space-y-1.5 ${className}`}>
      {(createdByName || createdAt) && (
        <div className="flex items-start gap-1.5 text-xs text-slate-400">
          <User size={11} className="shrink-0 text-slate-300 mt-0.5" />
          <span>
            Created by{' '}
            <span className="font-medium text-slate-600">{createdByName || '—'}</span>
            {createdAt && (
              <>
                {' '}on{' '}
                <span className="font-medium text-slate-600">{formatMyanmarDateTime(createdAt)}</span>
              </>
            )}
          </span>
        </div>
      )}
      {showUpdated && (
        <div className="flex items-start gap-1.5 text-xs text-slate-400">
          <Clock size={11} className="shrink-0 text-slate-300 mt-0.5" />
          <span>
            Last updated{' '}
            <span className="font-medium text-slate-600">{formatMyanmarDateTime(updatedAt)}</span>
          </span>
        </div>
      )}
    </div>
  );
}
